/**
 * 生成基础axios对象，并对请求和响应做处理
 */
import axios from 'axios'
import { ElNotification } from 'element-plus'
import gotoLoginDialog from '@/api/utils/gotoLogin.js'

let msgIns = null
const service = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    // headers: {
    //     'Content-Type': 'application/json;charset=UTF-8'
    // },
    timeout: 1000000
})
service.interceptors.request.use(config => {
    return config
})
// 响应拦截器
service.interceptors.response.use((response) => {
    const res = response.data
    return res
}, (error) => {
    console.log(error)
    if (msgIns) {
        msgIns.close()
    }
    console.log(error.code)
    if (error.code === 'ERR_BAD_REQUEST') {
        gotoLoginDialog.showDialog('系统繁忙，请稍后重试')
    } else {
        msgIns = ElNotification({
            title: '提示',
            message: '网络异常，请稍后重试',
            duration: 7000,
            type: 'error',
            offset: 0,
            customClass: 'el-notification--error'
        })
    }
})
export default service
